import {ENV} from '../utils';

export class RequestAPI {
    basePath = ENV.BASE_PATH;
    
    // create request
    async createRequest(accessToken, requestData) {
        try {
            const url = `${this.basePath}${ENV.API_ROUTES.REQUEST_REGISTRATION}`
            console.log(url);
            const params = {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                body: JSON.stringify(requestData)
            }

            const response = await fetch(url, params);
            console.log(response);
            const result= await response.json();

            if(response.status !== 201) throw result;
            return result;

        } catch (error) {
            console.log(error);
            throw error
        }
    }

    
}